import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {BounceRole} from "@bounce/shared/consumer/declarations";
import {HeaderRoot, HeaderToolbar} from "@bounce/shared/consumer/helpers";
import {Box} from "@mui/material";
import {BounceLogo} from "@bounce/shared/ui";
import {useLocation, useNavigate} from "react-router-dom";
import {clearNoLoginDialogFlags} from "~/constants/no-login-keys";
import {useAuth} from "@bounce/shared/contexts";
import {useLoginDestinationUrl} from "~/contexts";
import {urls} from "~/routes/consumerUrls";
import React from "react";
import MainMenu from "./menu/MainMenu";

const AccountHeader = () => {
  const {search} = useLocation();
  const {logoUrl} = usePartnerUi();
  const navigate = useNavigate();
  const {userRole} = useAuth();
  const {clearDestinationUrl} = useLoginDestinationUrl();

  const handleLogoClick = () => {
    if (userRole === BounceRole.NO_LOGIN_USER) {
      clearNoLoginDialogFlags();
      clearDestinationUrl();
    }
    navigate(urls.accounts.url + search);
  };

  return (
    <HeaderRoot>
      <HeaderToolbar variant={"dense"}>
        <MainMenu />
        <Box sx={{flexGrow: 1}} />
        <Box
          onClick={handleLogoClick}
          sx={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", cursor: "pointer"}}
        >
          {logoUrl ? (
            <Box component="img" src={logoUrl} alt="logo" width={"160px"} height={"40px"} />
          ) : (
            <BounceLogo width={"100px"} height={"21px"} />
          )}
        </Box>
      </HeaderToolbar>
    </HeaderRoot>
  );
};

export default AccountHeader;
